import * as React from "react";
import NumKey from "./NumKey";

interface IProps {
  className?: string;
  noBackground?: boolean;
  isLastNum?: boolean;
  isEnter?: boolean;
  children: React.ReactNode;
  handleAction?(): void;
}

interface IState {
  timer?: number;
}

class NumCol extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      timer: undefined
    };
  }

  public componentWillUnmount() {
    if (this.state.timer) {
      window.clearInterval(this.state.timer);
    }
  }

  public render() {
    const { children, noBackground, isEnter, isLastNum } = this.props;
    return (
      <NumKey
        noBackground={noBackground}
        onTouchStart={this.onTouchStart}
        onTouchMove={this.onTouchEnd}
        onTouchEnd={this.onTouchEnd}
        onTouchCancel={this.onTouchEnd}
        isEnter={isEnter}
        isLastNum={isLastNum}
      >
        {children}
      </NumKey>
    );
  }

  private onTouchStart = (e: any) => {
    if (this.props.handleAction) {
      this.props.handleAction();
    }

    this.setState(state => ({
      timer: state.timer || window.setInterval(this.tick, 500)
    }));

    e.preventDefault();
    e.target.style.pointerEvents = "none";
  };

  private onTouchEnd = (e: any) => {
    this.setState(state => {
      if (state.timer) {
        window.clearInterval(state.timer);
      }

      return {
        timer: undefined
      };
    });

    e.target.style.pointerEvents = "auto";
  };

  private tick = (e: any) => {
    if (this.state.timer && this.props.handleAction) {
      this.props.handleAction();
    }
  };
}

export default NumCol;



// WEBPACK FOOTER //
// ./src/components/common/NumPad/NumCol.tsx